module.exports = __webpack_public_path__ + "components/flag/static/square/sa-9377de8ef1d3db08721e1336d66da1e8.svg";